import { teacherMessages } from './en-US';

export const programId = '5da48519190a242176008518';

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com',
        useFingerprinting: true,
    },

    logLevel: 'error',
    messagesWithLocale: {
        'en-US': teacherMessages,
    },
};
